import { Component, OnInit, ChangeDetectionStrategy, Input, OnDestroy, TemplateRef, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormControl, Validators } from "@angular/forms";
import { DialogRef } from "@progress/kendo-angular-dialog"

import { Flow } from '../obj/Flow';
import { ApiService } from '../services/api.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-details',
    templateUrl: './details.component.html',
    styleUrls: ['./details.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class DetailsComponent implements OnInit, OnDestroy {

  @Input() flow: Flow;
  private subscription = new Subscription();

  public form: UntypedFormGroup;

  @ViewChild('formControl', { static: true }) 
  formControl: ElementRef<HTMLDivElement>;

  constructor(
    private apiService: ApiService,
    private formBuilder: UntypedFormBuilder,
    private dialogRef: DialogRef
  ) { 

      this.form = this.formBuilder.group({

        monitor: new FormControl(false),
        notifyOnFail: new FormControl(false),
        notifyOnMissed: new FormControl(false),
        missingDays: new FormControl(0),
        email: new FormControl("")
      });

  }

  ngOnInit(): void {   
    
    const notifyOnFail = this.form.get('notifyOnFail');
    const notifyOnMissed = this.form.get('notifyOnMissed');
    const email = this.form.get('email');

    const emailValildation = ()=>{

      const required = notifyOnFail!.value || notifyOnMissed!.value;
      if (required) {
        email!.setValidators([Validators.required])
      }
      else {
        email!.clearValidators();
      }

      email!.updateValueAndValidity();
    };

    notifyOnFail!.valueChanges.subscribe(emailValildation);
    notifyOnMissed!.valueChanges.subscribe(emailValildation);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSave() {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value); // pass result back to caller
    }
  }
}
